/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Helmet from '../../components/Helmet';
import { SELECTOR_IS_AUTH } from '../../redux/selectors/auth';

import Address from './Address';
import Login from './Login';
import ServiceDelivery from './ServiceDelivery';
import PaymentMethod from './PaymentMethod';
import Totals from './Totals';
import Resume from './Resume';
import ReactPixel from 'react-facebook-pixel';
import { KEYS } from './util';
import CheckoutBreadcrumbs from './breadcrumbs';
import {
  SELECTOR_SHOPPING_CART_PRODUCTS,
  SELECTOR_SHOPPING_CART_PRODUCTS_COUNT,
} from '../../redux/selectors/shoppingCart';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { FormControl, Grid, InputLabel, Modal, Select as MatSelect, alpha } from '@material-ui/core';
import AppButton from '../../components/AppButton';
import { Form, Formik } from 'formik';
import { listado } from '../../util/listado';
import * as yup from 'yup';
import { addNotification } from '../../redux/actions';
import api from '../../services/api';
import { ReportProblemOutlined } from '@material-ui/icons';
import { SELECTOR_ADDRESS_MAIN } from '../../redux/selectors/addresses';

const useStyles = makeStyles((t) => ({
  '@global': {
    body: {
      overflowX: 'hidden',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column-reverse',
    },
  },
  logotype: {
    width: 80,
    marginBottom: t.spacing(3),
    cursor: 'pointer',
  },
  content: {
    flexGrow: 1,
    paddingTop: t.spacing(6),
    paddingBottom: t.spacing(3),
    '@media screen and (min-width: 769px)': {
      paddingRight: t.spacing(6),
    },
  },
  sidebar: {
    position: 'relative',
    paddingTop: t.spacing(6),
    paddingBottom: t.spacing(3),
    flexShrink: 1,
    '@media screen and (min-width: 769px)': {
      paddingLeft: t.spacing(6),
      minWidth: 500,
      maxWidth: 500,
    },
    '&::after': {
      '@media screen and (min-width: 769px)': {
        content: '""',
        position: 'absolute',
        display: 'block',
        width: '300%',
        minHeight: '100vh',
        top: 0,
        left: 0,
        bottom: 0,
        backgroundColor: '#fafafa',
        boxShadow: '0 -1px 0 #e1e1e1 inset',
        borderLeft: `1px solid ${t.palette.divider}`,
        zIndex: -1,
      },
    },
  },
}));

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: '1px solid #e2e2e1',
    overflow: 'hidden',
    borderRadius: 4,
    backgroundColor: '#fcfcfb',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      backgroundColor: '#fff',
    },
    '&$focused': {
      backgroundColor: '#fff',
      boxShadow: `${alpha(theme.palette.primary.main, 0.2)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

Index.propTypes = {
  //
};

function Index(props) {
  const [step, setStep] = useState('info');
  const productsCount = useSelector(SELECTOR_SHOPPING_CART_PRODUCTS_COUNT);

  const [open, setOpen] = useState(false);
  // const [openOversize, setOpenOversize] = useState(false);
  const isAuth = useSelector(SELECTOR_IS_AUTH);

  const classes = useStyles();
  const history = useHistory();
  const match = useRouteMatch('/checkout/:section');
  const smScreen = useMediaQuery('(max-width:768px)');

  const isSameOrBeforeStep = useCallback(
    (k) => KEYS.findIndex((it) => it === k) === KEYS.findIndex((it) => it === step),
    [step],
  );

  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (productsCount) {
      setStep(match?.params?.section);
    } else {
      // history.goBack();
    }
  }, [match.params.section, productsCount]);

  useEffect(() => {
    ReactPixel.track('InitiateCheckout', {
      currency: 'COP',
    });
  }, []);

  const classesReddit = useStylesReddit();

  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuth && user && !user.customer_type) {
      setOpen(true);
    }
  }, [user, isAuth]);

  function onSubmit(values, { resetForm }) {
    const { customer_type } = values;

    try {
      api.users.patch(user.id, {
        customer_type,
      });
      setTimeout(() => {
        setOpen(false);
        window.location.reload();
      }, 500);
    } catch (e) {
      dispatch(addNotification(e.message, 'error'));
    } finally {
    }
  }

  const products = useSelector(SELECTOR_SHOPPING_CART_PRODUCTS);

  const ProductOversize = products?.some((item) => item.product.oversize === 'true');

  const fulfillment = useSelector(SELECTOR_ADDRESS_MAIN);

  // useEffect(() => {
  //   if (ProductOversize && fulfillment?.city_id !== 1122 && fulfillment) {
  //     setOpenOversize(ProductOversize);
  //   }
  // }, [ProductOversize, fulfillment]);

  // const handleClose = () => {
  //   setOpenOversize(false);
  // };

  return (
    <Container maxWidth={'lg'} className={classes.root}>
      <Helmet
        title={'Checkout'}
        description={''}
        og={{
          url: window.location.href,
          title: 'Estrategias LTDA',
          description: '',
          image: '',
        }}
      />
      <Modal destroyOnClose footer={false} centered open={open} width={450}>
        <Box
          padding={2}
          sx={{
            width: 500,
            backgroundColor: 'white',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            p: 2,
          }}
        >
          <Typography
            variant="h4"
            style={{
              fontSize: 20,
              fontWeight: 600,
              marginBottom: 10,
            }}
          >
            Seleccione a que sector pertecene
          </Typography>
          <Box marginTop={2}>
            <Formik
              enableReinitialize
              validationSchema={yup.object().shape({})}
              onSubmit={onSubmit}
              initialValues={{
                customer_type: '',
              }}
            >
              {({ values, isSubmitting, errors, handleChange, handleSubmit, setFieldValue }) => (
                <Form onKeyPress={(event) => event.key === 'Enter' && handleSubmit()}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Box mb={2}>
                        <FormControl fullWidth variant="filled">
                          <InputLabel htmlFor="filled-age-native-simple">Selecciona a que sector perteneces</InputLabel>
                          <MatSelect
                            native
                            disableUnderline
                            className={classesReddit.root}
                            value={values.customer_type}
                            defaultValue={values.customer_type}
                            onChange={(event) => {
                              setFieldValue('customer_type', event.target.value);
                            }}
                          >
                            <option aria-label="None" value="" />
                            {Object.entries(listado).map(([category, items]) => (
                              <optgroup label={category} key={category}>
                                {items.map((item, index) => (
                                  <option value={`${category}-${item}`} key={`${category}-${index}`}>
                                    {item}
                                  </option>
                                ))}
                              </optgroup>
                            ))}
                          </MatSelect>
                        </FormControl>
                      </Box>
                    </Grid>
                  </Grid>
                  <Box display="flex" justifyContent="center" alignItems="center" mt={3}>
                    <AppButton
                      type="submit"
                      round
                      disableElevation
                      variant="contained"
                      color="primary"
                      size="lg"
                      onClick={handleSubmit}
                      disabled={isSubmitting}
                    >
                      Envíar
                    </AppButton>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Box>
      </Modal>
      {/* <Modal destroyOnClose footer={false} centered open={openOversize} handleClose={handleClose} width={450}>
        <Box
          padding={2}
          sx={{
            width: 500,
            backgroundColor: 'white',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            p: 2,
          }}
        >
          <span
            style={{
              position: 'absolute',
              right: '10px',
              top: '8px',
              background: '#e7e7e7',
              borderRadius: '30px',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              lineHeight: '1',
              cursor: 'pointer',
            }}
            onClick={() => handleClose()}
          >
            X
          </span>
          <Typography
            variant="h4"
            style={{
              fontWeight: 600,
              marginBottom: 10,
              textAlign: 'center',
            }}
          >
            <ReportProblemOutlined
              style={{
                fontSize: 40,
              }}
            />
          </Typography>
          <Box marginTop={2}>
            <p>
              Los productos oversize no incluyen envío gratuito. Para disfrutar del envío gratis, te sugerimos realizar
              una compra separada para los productos que no son oversize.
            </p>
          </Box>
        </Box>
      </Modal> */}
      <Box className={classes.root}>
        <Box className={classes.content}>
          <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
            <img className={classes.logotype} src="/icons/new-logo.png" alt="" onClick={() => history.push('/')} />
            <Typography color="textPrimary">PROGRAMA TU PEDIDO</Typography>
          </Box>
          <Box display={'flex'} justifyContent={'center'}>
            <CheckoutBreadcrumbs step={step} />
          </Box>
          {!isAuth && <Login />}
          {smScreen && step !== 'info' && (
            <Box mt={3} mx={3}>
              <Totals />
            </Box>
          )}
          {isAuth && (
            <Box mt={3} mx={3}>
              <Resume />
            </Box>
          )}
          {isAuth && isSameOrBeforeStep('info') && (
            <Box mt={3} mx={3}>
              <Address />
            </Box>
          )}
          {isAuth && isSameOrBeforeStep('delivery') && (
            <Box mt={3} mx={3}>
              <ServiceDelivery />
            </Box>
          )}
          {isAuth && isSameOrBeforeStep('pay') && <PaymentMethod />}
        </Box>
        {!smScreen && (
          <Box className={classes.sidebar}>
            <Totals />
          </Box>
        )}
      </Box>
    </Container>
  );
}

export default Index;
